import api from "./index";

export const getCountryCodes = () => api.post("countrycode");
export const saveBookDemo = (data) => api.post("save-book-demo", data);
